import React from "react";
import cn from "classnames";
import { Card, Icon, Badge, Text } from "@telia/teddy";
import { SellingPoints } from "../../../../../../models";

import type { UspCardConfiguration } from "../UspList/uspCardPresentation";

const SubscriptionFeature = ({ item, variant, layout }: { item: SellingPoints } & UspCardConfiguration) => {
    const heading = (
        <Card.Heading variant="title-100" as={item.headingTag ?? "h2"}>
            {item.heading}
        </Card.Heading>
    );
    const description = item.content && (
        <Text asChild variant="paragraph-100">
            <div dangerouslySetInnerHTML={{ __html: item.content }} />
        </Text>
    );
    const action = item.url && (
        <Card.Button asChild variant="primary" iconOnly aria-label="Navigate">
            <a href={item.url}>
                <Icon name="arrow-right" aria-hidden="true" focusable="false" />
            </a>
        </Card.Button>
    );

    return (
        <Card
            layout={layout}
            variant={variant}
            className={cn("subscription-features__card", {
                "subscription-features__card--rich-card": layout === "rich-card",
                "subscription-features__card--rich-card-large": layout === "rich-card-large",
                "subscription-features__card--without-illustration": !item.icon,
                "subscription-features__card--product-negative": layout === "product" && variant === "purple-dark",
                "subscription-features__card--product-negative-linked":
                    layout === "product" && variant === "purple-dark" && !!item.url,
            })}
        >
            {item.badge && (
                <Badge
                    variant="success"
                    className="subscription-features__badge"
                    hideIcon
                    style={{
                        backgroundColor: item.badge.color,
                        color: item.badge.textColor,
                    }}
                >
                    {item.badge.text}
                </Badge>
            )}
            {item.icon && (
                <Card.Illustration className="subscription-features__illustration">
                    <Icon name={item.icon} size="lg" aria-hidden="true" focusable="false" />
                </Card.Illustration>
            )}
            {layout === "rich-card-large" ? (
                <Card.Content className="subscription-features__rich-content">
                    {heading}
                    {description}
                    {action}
                </Card.Content>
            ) : (
                <>
                    {heading}
                    {item.content && <Card.Content>{description}</Card.Content>}
                    {action}
                </>
            )}
        </Card>
    );
};

export default SubscriptionFeature;
